import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MessageErrorDetails } from '../../../messages/entities/message-error-details.model';
import { ModalWrapperComponent } from '@components/views/modal-wrapper/modal-wrapper.component';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ModalWrapperComponent]
})
export class ErrorModalComponent {
    readonly modalDataInput = input.required<MessageErrorDetails>();
}
